import { s } from "../../../../utilities/common"

export const EpochsIcon = () => (
  <svg
    width={s("40")}
    height={s("40")}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2.22222C6 1.61111 6.6 1 7.2 1H16.8C17.4 1 18 1.61111 18 2.22222V4.66667C18 8.33333 15.6 10.1667 12 12C8.4 10.1667 6 8.33333 6 4.66667V2.22222Z"
      stroke="#BFBFBF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 21.7778C6 22.3889 6.6 23 7.2 23H16.8C17.4 23 18 22.3889 18 21.7778V19.3333C18 15.6667 15.6 13.8333 12 12C8.4 13.8333 6 15.6667 6 19.3333V21.7778Z"
      stroke="#BFBFBF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 20H12H15"
      stroke="#BFBFBF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6.5C12.2761 6.5 12.5 6.72386 12.5 7C12.5 7.27614 12.2761 7.5 12 7.5C11.7239 7.5 11.5 7.27614 11.5 7C11.5 6.72386 11.7239 6.5 12 6.5Z"
      fill="white"
      stroke="#BFBFBF"
    />
  </svg>
)
